import React from 'react';
import { Helmet } from 'react-helmet';

const WebsiteRichSnippet = (): JSX.Element => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'https://schema.org/',
        '@type': 'WebSite',
        url: 'https://www.rapidformations.co.uk/',
        name: 'Rapid Formations',
      })}
    </script>
  </Helmet>
);

export default WebsiteRichSnippet;
